import scheduleNotificationsForTask from "./scheduleNotificationsForTask";

export const scheduleNotificationsForAllTasks = async (tasks) => {
  try {
    console.log("Scheduling notifications for tasks");
    // Get a list of tasks which have a deadline or a schedule
    const tasksToSchedule = Object.values(tasks).filter(
      (task) => task.deadline || task.schedule,
    );

    // Schedule notifications for tasks with deadlines (await all promises)
    await Promise.all(
      tasksToSchedule.map((task) => scheduleNotificationsForTask(task.taskId)),
    );
  } catch (e) {
    console.error(e);
  }
};
